<template>
    <div> 
      <div v-if="btn">

        <button v-if="messages.length > 0" @click ="showMessages('message')" type="button" class="btn btn-warning mr-3">
          TRASFERIMENTO <span class="badge badge-primary ml-2">{{ messages.length  }}</span>
        </button>
        <button v-if="booking.length > 0" @click ="showMessages('booking')" type="button" class="btn btn-warning mr-3 ">
          RICHIESTA TRASFERIMENTO <span class="badge badge-primary ml-2">{{ booking.length  }}</span>
        </button>
        
      </div>
      <div v-else>

        <div class="modal" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl">
        <div class="modal-content border-warning">
        <div class="modal-header bg-info">
          <h5 class="modal-title" id="staticBackdropLabel">
            <i style="color:black" class="fas fa-bell mr-3"></i>
            NOTIFICA DI {{ typeId ? 'TRASFERIMENTO' : 'RICHIESTA DI TRASFERIMENTO' }}</h5>            
        </div>
        <div class="modal-body">         
          <div v-if="typeId">
            <messageTable v-bind:messages="messages"></messageTable>            
          </div>
          <div v-else>           
            <bookingTable v-bind:booking="booking"></bookingTable>            
          </div>         
        </div>
        <div class="modal-footer">                    
        <button  @click="markAsRead()" type="button" class="btn btn-warning" >Segna come Letto</button>                                           
                             
        <button @click="btn=true"  type="button" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>                            
        </div>
        </div>
        </div>
      </div>  
      </div>        
    </div>
  </template>

  <script>
  
 import { mapGetters }      from 'vuex'
 //import api                 from '@/api'
 import bookingTable        from '@/components/sse/BookingTable.vue'
 import messageTable        from '@/components/sse/MessageTable.vue'
 
 import { db }                            from "@/api/Firebase"
 import {  ref,  onChildAdded,off,remove} from "firebase/database"
 
 

   export default {
    components: {bookingTable,messageTable},
    data() {
      return {
        messages    : [],
        booking     : [],
        bookingsRef : null,
        messagesRef : null,
        
        bookingsCallback: null,
        messagesCallback: null,


        btn         : true,
        typeId      : true,
      
        
      
      };
    },
    computed: 
    {
        ...mapGetters(['storeId']) , 
    },

 async mounted() {
    this.bookingsRef = ref(db, "bookings");
    this.messagesRef = ref(db, "messages");

    // 🔹 salva callback
    this.bookingsCallback = (snapshot) => {
      const booking = {
        id: snapshot.key,
        ...snapshot.val()
      };

      if (booking.shippedTo == this.storeId) {
        this.booking.push(booking);
        this.btn = true;
      }
    };

    this.messagesCallback = (snapshot) => {
      const message = {
        id: snapshot.key,
        ...snapshot.val()
      };

      if (message.shippedTo == this.storeId) {
        this.messages.push(message);
        this.btn = true;
      }
    };

    onChildAdded(this.bookingsRef, this.bookingsCallback);
    onChildAdded(this.messagesRef, this.messagesCallback);
  },






    async _mounted_()  {
      
       this.bookingsRef = ref(db, "bookings")
       this.messagesRef = ref(db, "messages")

      onChildAdded(this.bookingsRef, snapshot => {
            const booking = {
              id: snapshot.key,        // <-- ID generato da push()
              ...snapshot.val()        // <-- dati salvati
            };

        //  console.log("Nuovo booking :",booking.shippedTo);
          if(booking.shippedTo == this.storeId)          
          {
            this.booking.push(booking);
            this.btn = true
            //console.log('Booking AGGIUNTO',this.booking.length)
          }
      })
      onChildAdded(this.messagesRef, snapshot => {
            const message = {
              id: snapshot.key,        // <-- ID generato da push()
              ...snapshot.val()        // <-- dati salvati
            };

         // console.log("Nuovo messaggio :",message.shippedTo);
          if(message.shippedTo == this.storeId)          
          {
            this.messages.push(message);
            this.btn = true
           // console.log('MESSAGGIO AGGIUNTO')
          }
      })
      
            
    },
    beforeDestroy() {

        /*
        off(this.bookingsRef);
        off(this.messagesRef);
        */

        off(this.bookingsRef, 'child_added', this.bookingsCallback);
        off(this.messagesRef, 'child_added', this.messagesCallback);

        console.log('Listener rimosso.')
      
    },
    created() 
    {
        

    },
    
    methods:{

    getPathByType(item) {
        switch (this.typeId) 
        {
          case false:
            return `bookings/${item.id}`;
          case true:
            return `messages/${item.id}`;
          
        }
      },

        markAsRead() {


          let items = this.booking          
          if(this.typeId)            
          {
            items = this.messages            
          }
  
          items.forEach(item => {
                     
                const deletedRef = ref(db, this.getPathByType(item));
                  remove(deletedRef)
                .then(() => {
                //  console.log("Id eliminato");                                
              
                })
                  .catch(err => console.error(err));
                });
                
                if(this.typeId)                
                {
                  this.messages = []
                }
                else                
                {
                  this.booking = []
                }

          
      },

      
      showMessages(typeId)
      {
        this.btn      = false
       
        this.typeId   = (typeId == 'message') ? true : false
        this.$nextTick(()  => {                  
            $('#staticBackdrop').modal('show')
          })  
        
      }
    }
  }

  </script>
  <style scoped>

  
 td{
  color       : black;
  
 } 
 h4 {
    color       : black;
    font-family : 'Roboto Condensed';
    font-size   : 20px;
  }
 
  li {

    color       : black;
    font-family : 'Roboto Condensed';
    font-size   : 14px;
    font-weight : bold;

  }
 
  label {
    color       : black;
    font-family : 'Roboto Condensed';
    font-size   : 20px;
    cursor      : pointer;
  }

  .modal-footer {  
    justify-content: space-between;  
  }


  </style>